module.exports = __webpack_public_path__ + "assets/img/Sonance_014.8d9897e3.jpg";